import { Link } from 'react-router-dom';
import { NAV_LINKS, LEGAL_LINKS, CONTACT, SERVICES } from '@/data/site';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1B1B1B] border-t border-white/10">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <img
              src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/1561658e-8104-4b44-843d-3c206e044c64_compressed_KOR38-Dark-Background-1200-x-400-No-words.webp"
              alt="KOR38"
              className="h-12 w-auto object-contain mb-5"
            />
            <p className="font-label text-xs uppercase tracking-widest2 text-primary-400 mb-4">
              Personally Sourced · Carefully Connected
            </p>
            <p className="text-base leading-relaxed text-foreground-700 max-w-sm">
              KOR38 is a personal event-supplier sourcing and introduction service based in London,
              serving <strong className="font-semibold text-foreground-900">Greater London</strong>.
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-label text-xs uppercase tracking-[0.16em] text-foreground-900 mb-5">
              Explore
            </h3>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[15px] text-foreground-700 hover:text-primary-300 transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-label text-xs uppercase tracking-[0.16em] text-foreground-900 mb-5">
              Enquiries
            </h3>
            <ul className="space-y-3 text-[15px] text-foreground-700">
              {SERVICES.map((service) => (
                <li key={service.id}>
                  <Link
                    to={service.path}
                    className="hover:text-primary-300 transition-colors duration-300"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/apply" className="hover:text-primary-300 transition-colors duration-300">
                  Supplier applications
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 grid grid-cols-1 gap-6">
          <div className="flex flex-col sm:flex-row sm:flex-wrap gap-x-8 gap-y-3 text-[15px] text-foreground-700">
            <span className="flex items-center gap-2">
              <i className="ri-map-pin-line text-primary-400" aria-hidden="true"></i>
              {CONTACT.location} · serving {CONTACT.serviceArea}
            </span>
            <span className="flex items-center gap-2 flex-wrap">
              <i className="ri-mail-line text-primary-400" aria-hidden="true"></i>
              <a href={`mailto:${CONTACT.email}`} className="hover:text-primary-300">
                {CONTACT.email}
              </a>
            </span>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2 text-[15px]">
            {LEGAL_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-foreground-700 hover:text-primary-300 transition-colors duration-300"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <p className="text-[15px] text-foreground-700">
            &copy; {year} KOR38. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}